export class Locale {
  constructor(
    public key: string,
    public nativeName: string,
    public englishName: string,
    public deviceGroups?: any[]
  ) { }
}
